<template>
  <div v-if="reportOfSickness">
    <bordered-container title='Verzuimmelding'>
      <table class='confirmation-table confirmation-table-adjust-padding mt-2 mb-2'>
        <tr>
          <td>{{ 'report-of-sickness.first-of-absence' | translate }}</td>
          <td>{{ formatDate(stripTime(reportOfSickness.firstSickDate)) }}</td>
        </tr>
        <tr>
          <td>{{ 'report-of-sickness.disability-rate'| translate }}</td>
          <td>{{ reportOfSickness.disabilityRateAsPercentage }} %</td>
        </tr>
        <tr>
          <td>{{ 'report-of-sickness.arbo-report' | translate }}</td>
          <td>Nog te implementeren</td>
        </tr>
        <tr>
          <td>{{ 'report-of-sickness.safetynet'| translate }}</td>
          <td>{{ getSafetyNetText() }}</td>
        </tr>
        <tr>
          <td>{{ 'report-of-sickness.accident'| translate }}</td>
          <td>{{ getAccidentText() }}</td>
        </tr>
        <tr>
          <td>{{ 'report-of-sickness.third-party-liability' | translate }}</td>
          <td>{{ getThirdPartyLiabilityText() }}</td>
        </tr>
      </table>
    </bordered-container>
  </div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import { AccidentTypes } from '@/resources/models/reports-of-sickness';
import BorderedContainer from '@aevitae/aevitaeui/0_atoms/containers/BorderedContainer.vue';

export default {
  name: 'WorkStockItemNewReportOfSickness',
  components: {
    BorderedContainer
  },
  props: {
    serializedData: String
  },
  computed: {
    parsedData () {
      return JSON.parse(this.serializedData);
    },

    reportOfSickness () {
      return this.parsedData.after;
    },
    accident () {
      if (this.reportOfSickness != null) {
        if (this.reportOfSickness.accidentType === AccidentTypes.None || this.reportOfSickness.accidentType === 0) {
          return false;
        } else if (this.thirdPartyLiability != null) {
          return true;
        } else return null;
      } else return null;
    },
    thirdPartyLiability () {
      if (this.reportOfSickness != null) {
        if (this.reportOfSickness.accidentType === AccidentTypes.NoThirdPartyLiability || this.reportOfSickness.accidentType === 1) {
          return false;
        } else if (this.reportOfSickness.accidentType === AccidentTypes.ThirdPartyLiability || this.reportOfSickness.accidentType === 2) {
          return true;
        } else return null;
      } else return null;
    }
  },
  methods: {
    stripTime: (datetime) => datetime.split('T')[0],
    formatDate: (date) => Helpers.Dates.formatDate(date),

    getSafetyNetText () {
      if (this.reportOfSickness.safetyNet === true) return this.$t('report-of-sickness.form.yes-safetynet');
      else if (this.reportOfSickness.safetyNet === false) return this.$t('report-of-sickness.form.no-safetynet');
      else return this.$t('forms.no-entry');
    },
    getAccidentText () {
      if (this.accident === true) return this.$t('report-of-sickness.form.yes-accident');
      else if (this.accident === false) return this.$t('report-of-sickness.form.no-accident');
      else return this.$t('forms.no-entry');
    },
    getThirdPartyLiabilityText () {
      if (this.thirdPartyLiability === true) return this.$t('report-of-sickness.form.yes-third-party-liability');
      else if (this.thirdPartyLiability === false) return this.$t('report-of-sickness.form.no-third-party-liability');
      else return this.$t('forms.no-entry');
    }
  }
};
</script>

<style lang='scss' scoped>

.confirmation-table {
  tr {
    &:first-child {
      td {
        border-top: 0;
        padding-top: 0;
      }
    }
    &:last-child {
      td {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
.confirmation-table-adjust-padding {
  td {
    &:first-child {
      padding-left: 14px;
    }
    &:last-child {
      padding-right: 14px;
    }
  }
}
</style>
